/* Hortelã 2.0 · adicionar à sacola pelos blocos novos (Complete o look, Monte o look) */
(function () {
  if (window.H2) return;

  function sacola() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function atualizarContadores() {
    return fetch('/cart.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : (cart.item_count > 100 ? '~' : cart.item_count);
        });
        var barra = document.querySelector('free-ship-progress-bar');
        if (barra && typeof barra.init === 'function') barra.init(cart.items_subtotal_price);
        return cart;
      })
      .catch(function () {});
  }

  function adicionar(itens) {
    var drawer = sacola();
    var corpo = { items: itens };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      corpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (resposta) {
        if (!drawer) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return resposta; }
        if (resposta.sections) {
          drawer.getSectionsToRender().forEach(function (secao) {
            var alvo = document.getElementById(secao.id);
            var html = resposta.sections[secao.id];
            if (!alvo || !html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var form = doc.querySelector('#minicart-form');
            if (form) alvo.innerHTML = form.innerHTML;
          });
        }
        if (typeof drawer.cartAction === 'function') drawer.cartAction();
        drawer.classList.remove('is-empty');
        atualizarContadores();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hortela-2', cartData: resposta });
        }
        if (typeof drawer.open === 'function') drawer.open();
        return resposta;
      });
  }

  window.H2 = { adicionar: adicionar };

  /* Formata centavos em reais (usa o formatador do tema quando existe) */
  function reais(centavos) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.themeGlobalVariables && themeGlobalVariables.settings && themeGlobalVariables.settings.money_format) {
        return Shopify.formatMoney(centavos, themeGlobalVariables.settings.money_format);
      }
    } catch (err) {}
    var n = (centavos / 100).toFixed(2).split('.');
    return 'R$ ' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
  }

  /* Variação escolhida no formulário principal da página de produto */
  function variacaoAtual() {
    var form = document.querySelector('.product-detail__buy-buttons form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    var input = form ? form.querySelector('[name="id"]') : null;
    var id = input ? parseInt(input.value, 10) : 0;
    if (!id) {
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if (m) id = parseInt(m[1], 10);
    }
    return id;
  }

  /* Leve junto: esta peça + sugestão, com total e um botão só */
  document.querySelectorAll('[data-h2-leve-junto]').forEach(function (caixa) {
    var marcas = caixa.querySelectorAll('.h2-pdp-look__marca');
    var botao = caixa.querySelector('[data-h2-leve-junto-botao]');
    var total = caixa.querySelector('[data-h2-total]');
    var rotulo = caixa.querySelector('[data-h2-total-rotulo]');
    var nota = caixa.querySelector('[data-h2-frete-nota]');
    var minimo = parseInt(caixa.getAttribute('data-frete-minimo'), 10) || 0;
    if (!botao) return;

    function atualizar() {
      var soma = 0, qtd = 0;
      marcas.forEach(function (m) {
        m.closest('.h2-pdp-look__peca').classList.toggle('h2-pdp-look__peca--fora', !m.checked);
        if (m.checked) { soma += parseInt(m.getAttribute('data-preco'), 10) || 0; qtd++; }
      });
      if (total) total.textContent = reais(soma);
      if (rotulo) rotulo.textContent = qtd === 2 ? 'Os 2 por' : (qtd === 1 ? 'Total' : 'Nada marcado');
      if (nota) nota.hidden = !(qtd === 2 && minimo > 0 && soma >= minimo);
      botao.disabled = qtd === 0;
      botao.classList.remove('is-ok');
      botao.textContent = qtd === 2 ? botao.getAttribute('data-texto-2') : botao.getAttribute('data-texto-1');
    }
    marcas.forEach(function (m) { m.addEventListener('change', atualizar); });
    atualizar();

    botao.addEventListener('click', function () {
      var itens = [];
      marcas.forEach(function (m) {
        if (!m.checked) return;
        var id = m.getAttribute('data-h2-peca') === 'atual' ? variacaoAtual() : parseInt(m.getAttribute('data-id'), 10);
        if (id) itens.push({ id: id, quantity: 1 });
      });
      if (!itens.length) return;
      botao.disabled = true;
      botao.classList.add('is-carregando');
      adicionar(itens)
        .then(function () {
          botao.textContent = botao.getAttribute('data-texto-ok') || 'Na sacola';
          botao.classList.add('is-ok');
          setTimeout(function () { botao.disabled = false; atualizar(); }, 2500);
        })
        .catch(function (erro) {
          botao.disabled = false;
          var msg = (erro && (erro.description || erro.message)) || 'Não deu pra adicionar agora. Tenta de novo?';
          if (typeof showToast === 'function') showToast('<span class="ml-5">' + msg + '</span>', 5000, 'modal-error'); else alert(msg);
        })
        .finally(function () { botao.classList.remove('is-carregando'); });
    });
  });

  /* Estoque baixo: acompanha a cor escolhida */
  document.querySelectorAll('[data-h2-estoque]').forEach(function (aviso) {
    var mapa = {};
    (aviso.getAttribute('data-mapa') || '').split(',').forEach(function (par) {
      var p = par.split(':');
      if (p.length === 2 && p[0]) mapa[p[0]] = parseInt(p[1], 10);
    });
    var limite = parseInt(aviso.getAttribute('data-limite'), 10) || 3;
    var unica = aviso.getAttribute('data-unica') === 'true';
    var sufixo = aviso.getAttribute('data-sufixo') || 'nessa cor';
    var texto = aviso.querySelector('[data-h2-estoque-texto]');
    var ultimo = null;

    function mostrar(id) {
      if (!id || id === ultimo) return;
      ultimo = id;
      var q = mapa[String(id)];
      if (typeof q !== 'number' || isNaN(q) || q < 1 || q > limite) { aviso.hidden = true; return; }
      if (texto) {
        if (q === 1) texto.textContent = unica ? 'Última unidade' : 'Última unidade ' + sufixo;
        else texto.textContent = unica ? 'Últimas ' + q + ' unidades' : 'Só ' + q + ' ' + sufixo;
      }
      aviso.hidden = false;
    }
    function checar() { mostrar(variacaoAtual() || parseInt(aviso.getAttribute('data-inicial'), 10)); }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-detail__information, .product__item-js')) setTimeout(checar, 80);
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(checar, 80); });
    }
    setInterval(checar, 700);
    checar();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-h2-add]') : null;
    if (!form) return;
    e.preventDefault();
    var botao = form.querySelector('[type="submit"]');
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var qtd = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);
    if (botao) { botao.disabled = true; botao.classList.add('is-carregando'); }
    adicionar([{ id: id, quantity: qtd }])
      .then(function () {
        if (botao) {
          botao.textContent = botao.getAttribute('data-texto-ok') || 'Adicionado';
          botao.setAttribute('aria-pressed', 'true');
          botao.classList.add('is-ok');
        }
      })
      .catch(function () {
        if (botao) { botao.disabled = false; }
        form.submit();
      })
      .finally(function () { if (botao) botao.classList.remove('is-carregando'); });
  });
  /* ===== Celular: barra fixa de compra na página do produto + parcelas que acompanham a cor ===== */
  (function () {
    var barra = document.querySelector('[data-h2-barra-compra]');
    var parcelasPdp = document.querySelector('[data-h2-parcelas]');
    if (!barra) return;
    var mapa = {};
    (barra.getAttribute('data-mapa') || '').split(',').forEach(function (t) {
      var p = t.split(':');
      if (p.length === 3 && p[0]) mapa[p[0]] = { preco: parseInt(p[1], 10) || 0, ok: p[2] === '1' };
    });
    var qtdVariacoes = Object.keys(mapa).length;
    var opcao = barra.getAttribute('data-opcao') || '';
    var inicial = parseInt(barra.getAttribute('data-inicial'), 10) || 0;
    var escolheu = qtdVariacoes < 2 || /[?&]variant=\d+/.test(window.location.search);
    var botao = barra.querySelector('[data-botao]');
    var preco = barra.querySelector('[data-preco]');
    var parc = barra.querySelector('[data-parcelas]');
    var principal = barra.parentElement ? barra.parentElement.querySelector('button[name="add"]') : null;
    var mq = window.matchMedia('(max-width: 767.98px)');
    var ultimo = null;
    var principalNaTela = false;

    // Fora do bloco do produto, a barra fica presa à tela mesmo se algum pai tiver transform
    document.body.appendChild(barra);

    function parcela(c) { return reais(Math.round(c / 3)); }
    function atual() { return variacaoAtual() || inicial; }
    var temCor = opcao.indexOf('cor') > -1;
    var temTamanho = opcao.indexOf('tamanho') > -1;
    function textoEscolher() {
      if (temCor && temTamanho) return 'Escolher cor e tamanho';
      if (temCor) return 'Escolher a cor';
      if (temTamanho) return 'Escolher o tamanho';
      return 'Escolher a opção';
    }
    function rotular() {
      if (!botao) return;
      var v = mapa[String(atual())];
      if (!escolheu) { botao.disabled = false; botao.textContent = textoEscolher(); return; }
      if (v && !v.ok) { botao.disabled = true; botao.textContent = temCor && !temTamanho ? 'Esgotado nessa cor' : 'Esgotado nessa opção'; return; }
      botao.disabled = false;
      botao.textContent = 'Adicionar à sacola';
    }
    function sincronizar(forcar) {
      var id = atual();
      if (!id || (id === ultimo && !forcar)) return;
      ultimo = id;
      var v = mapa[String(id)];
      if (v) {
        if (preco) preco.textContent = reais(v.preco);
        if (parc) parc.textContent = 'ou 3x de ' + parcela(v.preco) + ' sem juros';
        if (parcelasPdp && v.preco > 0) parcelasPdp.innerHTML = 'ou 3x de <strong>' + parcela(v.preco) + '</strong> <span class="h2-parcelas__juros">sem juros no cartão</span>';
      }
      rotular();
    }
    function mostrar() {
      var ok = mq.matches && !principalNaTela;
      barra.classList.toggle('is-visivel', ok);
      document.body.classList.toggle('h2-com-barra', mq.matches);
    }

    // A barra aparece quando o botão principal "Adicionar à sacola" sai da tela.
    // Conferido pela posição na tela a cada rolagem (não depende só do IntersectionObserver, que alguns navegadores atrasam).
    function conferirPrincipal() {
      if (!principal) { principalNaTela = false; mostrar(); return; }
      var r = principal.getBoundingClientRect();
      var alt = window.innerHeight || document.documentElement.clientHeight || 0;
      principalNaTela = r.bottom > 0 && r.top < alt - 24;
      mostrar();
    }
    var esperaRolagem = null;
    function aoRolar() {
      if (esperaRolagem) return;
      esperaRolagem = setTimeout(function () { esperaRolagem = null; conferirPrincipal(); }, 80);
    }
    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar);
    if (principal && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        principalNaTela = entradas[entradas.length - 1].isIntersecting;
        mostrar();
      }, { rootMargin: '0px 0px -24px 0px' }).observe(principal);
    }
    if (mq.addEventListener) mq.addEventListener('change', conferirPrincipal); else if (mq.addListener) mq.addListener(conferirPrincipal);
    conferirPrincipal();
    setTimeout(conferirPrincipal, 1200);

    if (botao) {
      botao.addEventListener('click', function () {
        if (!escolheu) {
          escolheu = true;
          rotular();
          var seletor = document.querySelector('.product-detail__variant-picker');
          if (seletor) {
            var y = seletor.getBoundingClientRect().top + window.pageYOffset - 96;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
            seletor.classList.remove('h2-chamando');
            void seletor.offsetWidth;
            seletor.classList.add('h2-chamando');
          }
          return;
        }
        if (principal && !principal.disabled) principal.click();
      });
    }
    ['change', 'click'].forEach(function (tipo) {
      document.addEventListener(tipo, function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-detail__variant-picker')) {
          escolheu = true;
          setTimeout(function () { sincronizar(true); }, 120);
        }
      });
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { sincronizar(true); }, 80); });
    }
    setInterval(sincronizar, 800);
    sincronizar(true);
    rotular();
    mostrar();
  })();

  /* ===== Galeria da página do produto: contador de fotos (no celular a próxima foto aparece pela metade) ===== */
  (function () {
    if (!document.querySelector('.media-main-swiper')) return;
    var ligado = null;
    function montar() {
      var el = document.querySelector('.media-main-swiper .swiper-wrapper-preview');
      if (!el || !el.swiper || el.swiper === ligado) return;
      var sw = el.swiper;
      var n = sw.slides ? sw.slides.length : 0;
      var tag = el.parentNode.querySelector('.h2-galeria-contador');
      if (n < 2) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'h2-galeria-contador';
        tag.setAttribute('aria-hidden', 'true');
        el.parentNode.appendChild(tag);
      }
      ligado = sw;
      var marcar = function () { tag.textContent = (sw.activeIndex + 1) + ' / ' + sw.slides.length; };
      sw.on('slideChange', marcar);
      marcar();
    }
    montar();
    setInterval(montar, 1500);
  })();

  /* ===== Sacola: "Finalizar compra" direto da gaveta (usa o checkout da Yampi, igual ao botão da página da sacola) ===== */
  document.addEventListener('click', function (e) {
    var botao = e.target && e.target.closest ? e.target.closest('[data-h2-finalizar]') : null;
    if (!botao) return;
    e.preventDefault();
    if (botao.classList.contains('is-carregando')) return;
    var sacolaUrl = (window.routes && window.routes.cart_url) || '/cart';
    var irSacola = function () { window.location.href = sacolaUrl; };
    if (typeof window.yampiClick !== 'function') { irSacola(); return; }
    botao.classList.add('is-carregando');
    botao.setAttribute('aria-busy', 'true');
    var saiu = false;
    window.addEventListener('pagehide', function () { saiu = true; }, { once: true });
    try { window.yampiClick(); } catch (err) { irSacola(); return; }
    // Se o checkout não abrir (internet ruim, Yampi fora do ar), leva pra página da sacola
    setTimeout(function () {
      if (saiu || document.visibilityState !== 'visible') return;
      if (typeof window.hideYampiLoader === 'function') { try { window.hideYampiLoader(); } catch (err) {} }
      irSacola();
    }, 15000);
  });

  /* ===== Página da sacola no celular: barra fixa com o total e "Finalizar compra" ===== */
  (function () {
    var pagina = document.getElementById('main-cart-items');
    if (!pagina || !pagina.querySelector('.cart-info')) return;
    var mq = window.matchMedia('(max-width: 767.98px)');
    var barra = document.createElement('div');
    barra.className = 'h2-barra-compra h2-barra-compra--sacola';
    barra.setAttribute('aria-hidden', 'true');
    barra.innerHTML = '<div class="h2-barra-compra__info"><span class="h2-barra-compra__rotulo">Total</span><span class="h2-barra-compra__preco" data-preco></span></div><button type="button" class="h2-barra-compra__botao" tabindex="-1">Finalizar compra</button>';
    document.body.appendChild(barra);
    var preco = barra.querySelector('[data-preco]');
    var naTela = false;
    function alvo() {
      var y = pagina.querySelector('#checkoutympButton');
      if (y && y.offsetParent !== null) return y;
      return pagina.querySelector('#checkout');
    }
    function total() {
      var t = pagina.querySelector('.cart-info .totals');
      var m = t ? (t.textContent || '').match(/R\$\s?[\d.]+,\d{2}/) : null;
      if (preco) preco.textContent = m ? m[0].replace(/\s/, ' ') : '';
    }
    function mostrar() {
      var tem = !!pagina.querySelector('.cart-info');
      barra.classList.toggle('is-visivel', mq.matches && tem && !naTela);
      document.body.classList.toggle('h2-com-barra', mq.matches && tem);
    }
    // A barra aparece quando o botão "Finalizar compra" da página sai da tela (conferido pela posição a cada rolagem)
    function conferir() {
      var b = alvo();
      if (!b) { naTela = false; mostrar(); return; }
      var r = b.getBoundingClientRect();
      var alt = window.innerHeight || document.documentElement.clientHeight || 0;
      naTela = r.bottom > 0 && r.top < alt;
      mostrar();
    }
    var esperaRolagem = null;
    function aoRolar() {
      if (esperaRolagem) return;
      esperaRolagem = setTimeout(function () { esperaRolagem = null; conferir(); }, 80);
    }
    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar);
    function vigiar() {
      total();
      conferir();
    }
    barra.querySelector('button').addEventListener('click', function () {
      var b = alvo();
      if (b && !b.disabled) b.click();
    });
    if ('MutationObserver' in window) {
      var espera;
      new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(vigiar, 120); }).observe(pagina, { childList: true, subtree: true });
    }
    if (mq.addEventListener) mq.addEventListener('change', mostrar); else if (mq.addListener) mq.addListener(mostrar);
    vigiar();
    setTimeout(vigiar, 1500);
  })();
})();

/* Botão do WhatsApp no celular: mostra "Fale com a vendedora" no começo e vira só o ícone depois que a cliente rola */
(function () {
  var w = document.querySelector('.whatsapp-float.h2-whats');
  if (!w || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 767.98px)');
  var limite = document.querySelector('.h2-banners') ? 1300 : 500;
  function ver() {
    if (!mq.matches || window.scrollY < limite) return;
    w.classList.add('h2-whats--mini');
    window.removeEventListener('scroll', ver);
  }
  window.addEventListener('scroll', ver, { passive: true });
  ver();
})();
